import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DividerComponent } from '../../../../common/divider/divider.component';
import { GroupComponent } from '../../../../common/group/group.component';
import { ComponentVariantTransform, type Variants } from '../../../../utils/variant/variant';

type InnerPadding = 'default' | 'medium' | 'small';

@Component({
  selector: 'rt-dialog-footer',
  templateUrl: './dialog-footer.component.html',
  styleUrls: ['./dialog-footer.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.inner-padding-medium]': 'innerPadding() === "medium"',
    '[class.inner-padding-small]': 'innerPadding() === "small"',
    '[class.no-background]': '!hasBackground()',
    '[class]': 'variant()',
  },
  imports: [DividerComponent, GroupComponent],
})
export class DialogFooterComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    ['white', 'background', 'neutral-default', 'default', 'no-padding'],
  ];

  public readonly variant = input(...ComponentVariantTransform(DialogFooterComponent.VARIANTS));
  public readonly hasDivider = input<boolean>(true);
  public readonly hasOptionalActions = input<boolean>(false);
  public readonly hasBackground = input<boolean>(true);
  public readonly innerPadding = input<InnerPadding>('default');
}
